import CryptoJS from 'crypto-js';

const secretKey = 'DIJs0Nj1NYXD6dcAGb2oPTYA42w6qnjVa1MFxfxWHe69fVwjlBg2VTWdX'; // 

// التشفير
export const encryptToken = (token) => {
    return CryptoJS.AES.encrypt(token, secretKey).toString();
};

export const decryptToken = (accessType,tokenType) => {
    try {


        let token=""
        if(tokenType=="sso"){

            // استرجاع التوكن بناءً على accessType
            token = accessType === "Refreshtoken" ? sessionStorage.getItem("Refreshtoken") : sessionStorage.getItem("AccessToken");
        }
        if(tokenType=="manager"){

            // استرجاع التوكن بناءً على accessType
            token = accessType === "RefreshtokenManager" ? sessionStorage.getItem("RefreshtokenManager") : sessionStorage.getItem("AccessTokenManager");
        }
        // تحقق من أن التوكن ليس null أو undefined
        if (!token) {
            throw new Error('Token not found in sessionStorage');
        }

        // فك تشفير التوكن
        const bytes = CryptoJS.AES.decrypt(token, secretKey);
        const decryptedToken = bytes.toString(CryptoJS.enc.Utf8);

        // تحقق من أن فك التشفير لم يرجع نص فارغ
        if (!decryptedToken) {
            throw new Error('Failed to decrypt token');
        }

        return decryptedToken;

    } catch (error) {
        console.error('Error decrypting token:', error.message);
        return null; // أو يمكنك التعامل مع الخطأ بطريقة أخرى
    }
};